import * as React from "react";
import { Grid, Form } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { LinkObject } from "@teamprevent/common/model";

interface StateProps {
    availableTypes: LinkObject[];
}

interface OwnProps {
    selectedType: LinkObject;
    onSelectionChanged: (immunisationTypeTask: LinkObject) => void;
    onRemove: () => void;
}

type Props = StateProps & OwnProps;

export const ImmunisationTypeTaskSelector: React.FunctionComponent<Props> = (props) => {
    const onSelectionChanged = (selectionId: string) => {
        const selection = props.availableTypes.find(t => t.id === selectionId);
        if (selection) {
            props.onSelectionChanged(selection);
        }
    };

    return (
        <Grid.Row>
            <Grid.Column width="15">
                <Input.Dropdown
                    search
                    options={props.availableTypes.map(t => ({ text: t.name, value: t.id }))}
                    value={props.selectedType && props.selectedType.id}
                    dynamicOptions
                    onChange={onSelectionChanged}
                />
            </Grid.Column>
            <Grid.Column width="1">
                <Form.Button inline negative icon="remove" type="button" onClick={props.onRemove} floated="right" />
            </Grid.Column>
        </Grid.Row>
    );
};
